import type { BlockchainFilter } from "@/app/blockchains/filters/blockchain-filters-scope"
import type { Blockchain } from "@anaconda/core/blockchain/types"

export function shouldShowAptosLink(
  selectedBlockchain: BlockchainFilter,
  isEvmBlockchain: (blockchain: Blockchain) => boolean,
): boolean {
  if (selectedBlockchain === "ALL") {
    return false
  }

  return isEvmBlockchain(selectedBlockchain)
}
